if not App.angularApp?
    return

App.angularApp.directive 'mfUiSelectOnBlur', ->
    require: 'uiSelect'
    restrict: 'A'
    link: (scope, ele, attrs, ctrl) ->
        ele.on 'blur', 'input.ui-select-search', (e) ->
            scope.$eval attrs.mfUiSelectOnBlur
